module.exports = __webpack_public_path__ + "static/media/homer-computer.3ab88540.gif";